import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
// core components
import styles from "assets/jss/material-kit-react/components/headerStyle.js";
import PARAMS from "utils/PARAMS";
import RoomIcon from '@material-ui/icons/Room';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';

const useStyles = makeStyles(styles);

export default function Header(props) {
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, rightLinks, leftLinks, fixed, absolute, isLogin } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed
  });
  const brandComponent = <Button className={classes.title}>
    {!isLogin && <img src={require("assets/img/logo.png")} alt="Sadeco"  style={{width: 140, backgroundColor: '#fff', borderRadius: 15, marginRight: 15, cursor: 'pointer'}} onClick={() => {window.location.href = `${PARAMS.baseUrl}`}}/>}
  </Button>;
  return (
    <AppBar className={appBarClasses}>
      <Toolbar className={classes.container}>
        {leftLinks !== undefined ? brandComponent : null}
        <div className={classes.flex}>
          {leftLinks !== undefined ? (
            <Hidden smDown implementation="css">
              {leftLinks}
            </Hidden>
          ) : (
            brandComponent
          )}
        </div>
        <Hidden smDown implementation="css">
          {/*rightLinks*/}
          <div style={{display: 'flex', justifyContent: 'center', alingItems: 'center'}}>
            <div style={{marginRight: 30}}>
              <span style={{color: '#B3B3B3', fontSize: 12, fontFamily: "LatoSemiBold", marginRight: 10}}><RoomIcon style={{fontSize: 18, color: '#B3B3B3', marginRight: 3, marginBottom: -3}}/>Avda.Medina Azahara. 14005 Córdoba</span>
              <span style={{color: '#B3B3B3', fontSize: 12, fontFamily: "LatoSemiBold"}}><MailOutlineIcon style={{fontSize: 18, color: '#B3B3B3', marginRight: 3, marginBottom: -3}}/>buzon@sadeco.es</span>
            </div>
            <div style={{display: 'flex'}}>
              <a style={{color: '#b8b8b9', textDecoration: 'none'}} href="https://www.facebook.com/sadeco.cordoba" target="_blank" rel="noopener noreferrer">
                <span className={classes.rrssIcons}><FacebookIcon /></span>
              </a>
              <a style={{color: '#b8b8b9', textDecoration: 'none'}} href="https://twitter.com/sadecocordoba" target="_blank" rel="noopener noreferrer">
                <span className={classes.rrssIcons}><TwitterIcon /></span>
              </a>
              <a style={{color: '#b8b8b9', textDecoration: 'none'}} href="https://www.youtube.com/user/CanalSadeco/" target="_blank" rel="noopener noreferrer">
                <span className={classes.rrssIcons}><YouTubeIcon /></span>
              </a>
              <a style={{color: '#b8b8b9', textDecoration: 'none'}} href="https://www.instagram.com/sadecocordoba/" target="_blank" rel="noopener noreferrer">
                <span className={classes.rrssIcons}><InstagramIcon /></span>
              </a>
            </div>
          </div>
        </Hidden>
      </Toolbar>
      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={handleDrawerToggle}
        >
          <div className={classes.appResponsive}>
            {leftLinks}
            {rightLinks}
          </div>
        </Drawer>
      </Hidden>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "custom",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "custom",
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};
